/// <amd-module name="typeahead/features/NearbyAirportParamModifier" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        lobs: ["FLIGHTS"],
    },
];

const featureFlag: string = "nearby_airport";

export class NearbyAirportParamModifier implements IExperimentalFeature, IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
